export const actionTypes = {
    LOAD_MEASUREMENT_LEGACY: 'operationalParameters_v2/LOAD_MEASUREMENT_OLD',
    LOAD_MEASUREMENT: 'operationalParameters_v2/LOAD_MEASUREMENT',
};
